










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ztComponents from '@sichern/ui-elements'
import VCalendar from 'v-calendar'
import '@sichern/ui-elements/dist/ztelements.css'
import Paginate from 'vuejs-paginate'
import Search from '../../apiClient/Search'
import User from '../../apiClient/User'
import Folders from '../../apiClient/Folders'
import OnBoarding from '../../apiClient/OnBoarding'
import SichernIntegration from '../../apiClient/SichernIntegration'
import VueElementLoading from 'vue-element-loading'
import PieChart from 'vue-pie-chart/src/PieChart.vue'
import swal from 'sweetalert2'
import { mapGetters } from 'vuex'
import bus from '../../bus'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import FilterIcon from '../../components/pickup/FilterIcon.vue'
import moment from 'moment'
import Company from '../../apiClient/Company'
import UserManagement from '@/apiClient/UserManagement'
import { hasIntegration } from '@/utils/getIntegrations'

Vue.use(VCalendar)
Vue.use(ztComponents)

@Component({
  components: {
    VueElementLoading,
    Multiselect,
    'pie-chart': PieChart,
    paginate: Paginate,
    FilterIcon
  },
  computed: {
    ...mapGetters(['getSearchRRHH', 'getUser', 'isActionAllowed', 'hasIntegration', 'hasAnyIntegration', 'getHasPerformanceIntegration'])
  }
})
export default class ListEmployees extends Vue {
  isActiveMode: boolean = false
  activeNotificationModal: boolean = false
  showResponseNotification: boolean = false
  responseNotification: any
  isExportingLoader: boolean
  obApi: OnBoarding
  ob: Search
  vi: SichernIntegration
  total: number
  limit: number
  page: number
  totalPage: number
  sort: string
  show: boolean
  showFolderSpinner: boolean
  notFound: boolean
  user: any
  search: any
  data_list: any
  data_export: any
  getSearchRRHH: any
  getHasPerformanceIntegration: any
  userClient: User
  companyId: any
  userSector: any
  userLocation: any
  foldersClient: Folders
  foldersUser: any
  companyFolders: any
  name: 'employeeslist;'
  userActive: any
  showResetPass: boolean

  form: {
    resetPass: {
      mail: string
      id: any
      user: string
    }
  }
  activeId: any
  overShowFolder: boolean
  mouseOverReset: boolean
  bufferFree: boolean
  isLoading: boolean
  paramsPositionReport: any
  getUser: any
  isActionAllowed: any
  noLoadingStatus: boolean
  userHaveDeleteMassivePerm: boolean
  userHaveResetPassPerm: boolean
  userHaveDeletePerm: boolean
  userHaveConfigPerm: boolean
  userHaveCreationPerm: boolean
  userHaveAdminPerm: boolean
  userHaveAssignProfilePerm: boolean
  userHaveNewUserCreationPerm: boolean
  searchDisabled: boolean
  asyncFiltersLoading: boolean
  massiveApprove: boolean
  hasVPIntegration: boolean
  isIEbrowser: boolean
  companyUser: Company
  userManagement: UserManagement
  profilesCompany: any
  integrationsLoaded: boolean
  debounceSearchingEmployees: () => void
  data() {
    return {
      chip: true,
      baseUrl: process.env.VUE_APP_BASE,
      isExportingLoader: false,
      locationOrigin: location.origin,
      data_list: [],
      total: '',
      page: 1,
      limit: 25,
      show: false,
      advanced_search: false,
      notFound: false,
      isActive: true,
      isInactive: true,
      search: {
        user: '',
        legajo: '',
        sector: {
          value: this.$t('message.search_text_select_sector'),
          data: []
        },
        locacion: {
          value: this.$t('message.search_text_select_locacion'),
          data: []
        },
        centroDeCostos: {
          value: {
            cost_center: this.$t('message.search_text_select_centroDeCostos')
          },
          data: []
        },
        cargo: {
          value: '',
          data: []
        },
        report: {
          value: '',
          datos: []
        },
        sectorLocacion: {
          value: this.$t('message.search_text_select_locacion'),
          data: [],
          valueArr: [],
          valueClosedArr: {},
          formValue: ''
        },
        departureDate: {
          placeholder: null,
          start: null,
          end: null
        },
        admissionDate: {
          start: '',
          end: ''
        },
        estatus: {
          activo: 1,
          onBoarding: 2,
          inactivo: 3
        },
        checkedEstatus: [],
        empleado: {
          value: 1
        },
        rrhh: {
          value: 2
        },
        esRRRHHSector: false,
        aprobador: {
          active: false,
          value: 1
        },
        primer_login: {
          active: false,
          value: 0
        },
        checkedTipoPerfil: [],
        currentSort: 'name',
        currentSortDir: 1,
        currentPage: 0,
        selected: [],
        allSelected: false,
        userIds: [],
        totaluserIdsOnboarding: []
      },
      companyId: null,
      userSector: null,
      userLocation: null,
      foldersUser: [],
      companyFolders: [],
      userActive: 0,
      showFolders: false,
      showResetPass: false,
      form: {
        resetPass: {
          mail: '',
          id: '',
          user: ''
        }
      },
      activeId: 0,
      showFolderSpinner: false,
      overShowFolder: false,
      mouseOverReset: false,
      bufferFree: true,
      isLoading: false,
      paramsPositionReport: '',
      noLoadingStatus: true, // cambiar a false al volver a agregar las validaciones
      userHaveCreationPerm: false,
      userHaveAdminPerm: false,
      userHaveConfigPerm: true,
      userHaveDeletePerm: false,
      userHaveDeleteMassivePerm: false,
      userHaveResetPassPerm: true,
      userHaveAssignProfilePerm: true,
      searchDisabled: false,
      asyncFiltersLoading: true,
      massiveApprove: false,
      hasVPIntegration: false,
      isIEbrowser: false,
      profilesCompany: [],
      debounceSearchingEmployees: null,
      integrationsLoaded: false
    }
  }

@Watch('$store.state.integrations', { deep: true, immediate: true })
  onIntegrationsChange() {
    if (this.$store.state.integrations !== null && typeof this.$store.state.integrations === 'object') {
      this.integrationsLoaded = true
    }
  }

  async created() {
    this.ob = new Search()
    this.userClient = new User()
    this.companyUser = new Company()
    this.foldersClient = new Folders()
    this.obApi = new OnBoarding()
    this.vi = new SichernIntegration()
    await this.checkActiveSichernPeopleIntegration()
    await this.setPermissions()
    this.searchSector()
    this.searchLocacion()
    this.searchCargo()
    this.clearReport()
    this.clearPosition()
    this.getIdCompany()
    this.getFolders()
    this.searchCentroDeCostos()
    this.isIE()
    this.debounceSearchingEmployees = _.debounce(
      (value) => this.searchingEmployees(value),
      500
    )

    this.limit = this.$store.state.limit
    if (this.getHasPerformanceIntegration) {
      // Solo setear estado onboarding, NO ejecutar búsqueda automática
      // El usuario debe dar click en "Buscar" para que se apliquen los filtros de sector/locación
      this.search.checkedEstatus = [2]
    } else if (this.$route.params.status) {
        switch (this.$route.params.status) {
          case 'active':
            this.search.checkedEstatus.push(1)
            break
          case 'onboarding':
            this.search.checkedEstatus.push(2)
            break
          default:
            break
      }

      if (typeof this.search.currentPage === 'undefined') {
        this.search.currentPage = 0
      }

      this.searchEmployees(
        this.limit,
        this.search.currentPage === 0 ? 1 : this.search.currentPage,
        this.search.currentSort,
        true
      )
    } else if (this.getSearchRRHH) {
      if (
        !(
          Object.keys(this.getSearchRRHH).length === 0 &&
          this.getSearchRRHH.constructor === Object
        )
      ) {
        this.search = this.getSearchRRHH
        if (typeof this.search.currentPage === 'undefined') {
          this.search.currentPage = 0
        }

        this.searchEmployees(
          this.limit,
          this.search.currentPage === 0 ? 1 : this.search.currentPage,
          this.search.currentSort,
          true
        )
      }
    }

    try {
      const userManagementApi = new UserManagement()
      const infoUser = JSON.parse(localStorage.getItem('user'))
      const { data } = await userManagementApi.getProfileCompany(
        infoUser.empresa.id,
        {
          profileTypes: '[4,8]'
        }
      )
      this.profilesCompany = data
    } catch (e) {
      this.profilesCompany = []
    }

    bus.$on('userchange', () => {
      this.$store.dispatch('setSearchRRHH', { search: {} })
      this.data_list = []
      this.profilesCompany = []
    })

    /* mapeando parametros desde nuevo dashboard rrhh */
    const queryParamStatus = this.$route.query.status
    if (queryParamStatus && queryParamStatus.length > 0) {
      if (queryParamStatus === 'enrollment') {
        this.search.checkedEstatus.push(1)
      }
      if (queryParamStatus === 'onboarding') {
        this.search.checkedEstatus.push(2)
      }
      this.searchEmployees(this.limit, 1, this.search.currentSort, true)
    }
  }

  @Watch('form.details.content')
  
  goToOrganizationChart() {
    window.location.replace(window.origin + '/v3/organization-chart')
  }

  goToLoadEmployee() {
    window.location.href = window.origin + '/v3/employee/create/individual'
  }

  goToLoadEmployeeMassive() {
    window.location.href = window.origin + '/v3/employee/create/massive'
  }

  onChangedTextArea() {
    let textArea = document.querySelectorAll('textarea')[0]
    let characterCountTextArea = document.querySelector(
      '#characterCountTextArea'
    )
    characterCountTextArea.setAttribute(
      'value',
      textArea.value.length.toString()
    )
  }

  reloadTable(page) {
    this.search.currentPage = page
    this.searchEmployees(this.limit, page, this.search.currentSort, true)
  }
  reloadTableCountLimit() {
    this.searchEmployees(this.limit, 1, this.search.currentSort)
    this.$store.dispatch('setLimit', this.limit)
  }

  buildFilter() {
    var params = new URLSearchParams()
    if (this.search.user.length != 0) {
      params.append('principal', this.search.user)
    }
    if (this.search.legajo.length != 0) {
      params.append('legajo', this.search.legajo)
    }
    if (this.search.checkedEstatus.length != 0) {
      params.append('estado', this.search.checkedEstatus)
    }
    if (this.search.checkedTipoPerfil.length != 0) {
      const value = [...this.search.checkedTipoPerfil]
      if (value[0] === 1 || value[0] === 2) {
        params.append('perfil', this.search.checkedTipoPerfil)
      } else {
        params.append('perfilid', this.search.checkedTipoPerfil)
      }
    }
    if (
      this.search.sector.length != 0 &&
      this.search.sector.value != this.$t('message.search_text_select_sector')
    ) {
      params.append('sector', this.search.sector.value)
    }
    if (
      this.search.locacion.length != 0 &&
      this.search.locacion.value !=
        this.$t('message.search_text_select_locacion')
    ) {
      params.append('locacion', this.search.locacion.value)
    }
    if (
      this.search.centroDeCostos.length != 0 &&
      this.search.centroDeCostos.value.cost_center !=
        this.$t('message.search_text_select_centroDeCostos')
    ) {
      params.append(
        'centrocostos',
        this.search.centroDeCostos.value.cost_center
      )
    }
    if (
      this.search.cargo.length != 0 &&
      this.search.cargo.value != null &&
      this.search.cargo.value != ''
    ) {
      params.append('cargo', this.search.cargo.value)
    }
    if (
      this.search.report.length != 0 &&
      this.search.report.value != null &&
      this.search.report.value != ''
    ) {
      params.append('reporta', this.search.report.value.cuil)
    }

    if (this.search.sectorLocacion.formValue != '') {
      params.append('sectorLocacion', this.search.sectorLocacion.formValue)
    } else if (this.search.sectorLocacion.data.length > 0) {
      var res = []
      for (
        var i = 0;
        i < this.search.sectorLocacion.valueClosedArr.length;
        i++
      ) {
        res.push(this.search.sectorLocacion.valueClosedArr[i].id)
      }
      params.append('sectorLocacion', res.join(','))
    }
    if (this.hiring_date_from != '' && this.hiring_date_until != '') {
      params.append('hiring_date_from', this.hiring_date_from)
    }
    if (this.hiring_date_from != '' && this.hiring_date_until != '') {
      params.append('hiring_date_until', this.hiring_date_until)
    }
    if (this.search.aprobador.active === true) {
      params.append('aprobador', this.search.aprobador.value)
    }
    if (this.search.primer_login.active === true) {
      params.append('primerlogin', this.search.primer_login.value)
    }
    if (this.search.currentSort) {
      params.append('orderfield', this.search.currentSort)
    }
    if (this.search.currentSortDir) {
      params.append('ordersort', this.search.currentSortDir)
    }

    if (
      this.search.departureDate &&
      this.search.departureDate.start &&
      this.search.departureDate.end
    ) {
      params.append('fechadesvincdesde', this.search.departureDate.start)
      params.append('fechadesvinchasta', this.search.departureDate.end)
    }

    return params
  }

  closeChip(item, index) {
    this.search.sectorLocacion.valueClosedArr[index].selected = false
    this.updateSearchSectLocValue()
  }

  openChip(item, index) {
    this.search.sectorLocacion.valueClosedArr[index].selected = true
    this.updateSearchSectLocValue()
  }

  updateSearchSectLocValue() {
    this.search.sectorLocacion.formValue = ''
    var res = []
    for (var i = 0; i < this.search.sectorLocacion.valueClosedArr.length; i++) {
      if (this.search.sectorLocacion.valueClosedArr[i].selected)
        res.push(this.search.sectorLocacion.valueClosedArr[i].id)
    }
    this.search.sectorLocacion.formValue = res.join(',')
  }

  searchEmployees(limit, page, sort, comeFromReload = false, event = null) {
    this.searchDisabled = true
    if (sort === this.search.currentSort && !comeFromReload) {
      this.search.currentSortDir = this.search.currentSortDir === 1 ? 2 : 1
    }
    this.search.currentSort = sort
    this.search.currentPage = page
    this.show = true
    var params = this.buildFilter()
    this.ob
      .searchEmployees(limit, page, params)
      .then((res: any) => {
        if (res.status === 200) {
          let totalPageInt = Math.trunc(
            res.data.pagination.total / res.data.pagination.limit
          )
          this.show = false
          this.notFound = false
          this.data_list = res.data.results.data
          this.total = res.data.pagination.total
          this.limit = res.data.pagination.limit
          this.page = res.data.pagination.offset
          this.totalPage =
            res.data.pagination.total % res.data.pagination.limit > 0
              ? totalPageInt + 1
              : totalPageInt
          this.searchDisabled = false
          this.$nextTick(() => {
            if (event) {
              const element = <HTMLInputElement>event.target
              element.focus()
            }
          })
        }
      })
      .catch((error: any) => {
        this.show = false
        this.data_list = ''
        this.notFound = true
        this.searchDisabled = false
        this.$nextTick(() => {
          if (event) {
            const element = <HTMLInputElement>event.target
            element.focus()
          }
        })
      })
  }

  employeeView(item) {
    this.$router.push({ name: 'employee', params: { id: item.id } })
  }
  showPercent(IOC, IOT, type) {
    if (type === 'ratio') {
      var percent: number = Math.round((IOC / IOT) * 100) / 100
      return percent
    } else {
      var label: string = Math.round((IOC / IOT) * 100).toString()
      return label + '%'
    }
  }
  buildColorGraph(percentData, type) {
    //var percent =  Math.round((IOC) / (IOT)*100)/100;
    let percent = Math.round(percentData) / 100
    var item: string
    if (percent === 0) {
      type === 'color'
        ? (item = '#ccc')
        : (item = this.$t('message.ob_not_started').toString())
    } else if (percent > 0 && percent <= 0.2) {
      type === 'color'
        ? (item = '#F16B6C')
        : (item = item = this.$t('message.ob_not_completed').toString())
    } else if (percent > 0.2 && percent <= 0.99) {
      type === 'color'
        ? (item = '#FCAB10')
        : (item = this.$t('message.ob_not_completed').toString())
    } else if (percent === 1) {
      type === 'color'
        ? (item = '#54CAA6')
        : (item = this.$t('message.ob_completed').toString())
    }
    return item
  }
  searchSector() {
    this.userClient
      .listSector()
      .then((res: any) => {
        this.search.sector.data = res.data.results.data
        this.search.sector.data.unshift(
          this.$t('message.search_text_select_sector')
        )
      })
      .catch((error: any) => {})
  }

  searchLocacion() {
    this.userClient
      .listLocacion()
      .then((res: any) => {
        this.search.locacion.data = res.data.results.data
        this.search.locacion.data.unshift(
          this.$t('message.search_text_select_locacion')
        )
      })
      .catch((error: any) => {})
  }
  searchCentroDeCostos() {
    this.userClient
      .listCentroDeCostos()
      .then((res: any) => {
        this.search.centroDeCostos.data = res.data.data
        this.search.centroDeCostos.data.unshift({
          cost_center: this.$t('message.search_text_select_centroDeCostos')
        })
      })
      .catch((error: any) => {})
  }
  searchCargo() {
    this.search.cargo.value = []
    this.userClient
      .listPosition()
      .then((res: any) => {
        this.search.cargo.data = res.data.results.data[0]
      })
      .catch((error: any) => {})
  }
  searchSectorLocacion() {
    this.companyUser
      .getSectorAndLocation()
      .then((res: any) => {
        let dataArr = res.data.data.map((item) => {
          item.id = item.id.replace(/,/g, '&#44;')
          return item
        })
        if (dataArr.length > 0) {
          this.search.esRRRHHSector = true
        }
        this.search.sectorLocacion.data = dataArr
        this.search.sectorLocacion.valueArr = []
        this.search.sectorLocacion.valueClosedArr = []
        this.search.sectorLocacion.valueArr =
          this.search.sectorLocacion.formValue.split(',')

        for (let i = 0; i <= dataArr.length; i++) {
          if (typeof dataArr[i].id === 'string') {
            let isSelected = this.search.sectorLocacion.valueArr.includes(
              dataArr[i].id
            )
              ? true
              : false
            this.search.sectorLocacion.valueClosedArr.push({
              id: dataArr[i].id,
              value: dataArr[i].name,
              selected: isSelected
            })
          }
        }
      })
      .catch((error: any) => {})
      .finally(() => {
        this.asyncFiltersLoading = false
      })
  }

  departureRangeDate(range) {
    if (range) {
      const start = moment(range.start)
      const end = moment(range.end)
      this.search.departureDate.start = start.format('YYYY-MM-DD')
      this.search.departureDate.end = end.format('YYYY-MM-DD')
      this.search.departureDate.placeholder = `${start.format(
        'DD/MM/YYYY'
      )} - ${end.format('DD/MM/YYYY')}`
    }
  }

  get dateSearchText() {
    let dateSearchText = ''
    if (this.search.admissionDate && this.search.admissionDate.start !== '') {
      let admissionDateStart = moment(this.search.admissionDate.start)
      let admissionDateEnd = moment(this.search.admissionDate.end)

      dateSearchText = `${admissionDateStart.format(
        'DD/MM/YYYY'
      )} - ${admissionDateEnd.format('DD/MM/YYYY')}`
    }

    return dateSearchText
  }

  get hiring_date_from() {
    let hdf = ''
    if (this.search.admissionDate && this.search.admissionDate.start !== '') {
      let admissionDateStart = moment(this.search.admissionDate.start)

      hdf = `${admissionDateStart.format('YYYY-MM-DD')}`
    }
    return hdf
  }

  get hiring_date_until() {
    let hdu = ''
    if (this.search.admissionDate && this.search.admissionDate.end !== '') {
      let admissionDateEnd = moment(this.search.admissionDate.end)

      hdu = `${admissionDateEnd.format('YYYY-MM-DD')}`
    }
    return hdu
  }

  async setPermissions() {    
    this.userHaveResetPassPerm = this.isActionAllowed(96)
    this.userHaveConfigPerm = this.isActionAllowed(94)
    this.userHaveAdminPerm = this.isActionAllowed(7)
    this.userHaveAssignProfilePerm = this.isActionAllowed(106)
    this.userHaveNewUserCreationPerm = this.isActionAllowed(317)
    /*
    const noOnBoardingPerm = !this.isActionAllowed(73) && !this.isActionAllowed(74)  

    if (this.hasVPIntegration && noOnBoardingPerm) {
      this.userHaveCreationPerm = false
      this.userHaveDeletePerm = false
      this.userHaveDeleteMassivePerm = false
    } else {
      this.userHaveCreationPerm = this.isActionAllowed(93)
      this.userHaveDeletePerm = this.isActionAllowed(95)
      this.userHaveDeleteMassivePerm = this.isActionAllowed(40)
    }
    this.noLoadingStatus = true
    */
   
    this.userHaveCreationPerm = this.isActionAllowed(93)
    this.userHaveDeletePerm = this.isActionAllowed(95)
    this.userHaveDeleteMassivePerm = this.isActionAllowed(40)
  }

  selectAll() {
    var user: any
    this.search.userIds = []
    if (!this.search.allSelected) {
      for (user in this.data_list) {
        if (this.data_list[user].estado_empresa === '2') {
          this.search.userIds.push(this.data_list[user].id.toString())
        }
      }
    }
  }
  updateCheckall() {
    this.totalOnboarding()
    if (
      this.search.userIds.length === this.search.totaluserIdsOnboarding.length
    ) {
      this.search.allSelected = true
    } else {
      this.search.allSelected = false
    }
  }
  totalOnboarding() {
    var user: any
    this.search.totaluserIdsOnboarding = []
    for (user in this.data_list) {
      if (this.data_list[user].estado_empresa === '2') {
        this.search.totaluserIdsOnboarding.push(
          this.data_list[user].id.toString()
        )
      }
    }
  }

  activeOnb(id) {
    const approvePromises = []
    let that = this
    swal({
      title: this.$t('message.ob_submit_massive_swal_title').toString(),
      text: this.$t('message.ob_submit_swal_text').toString(),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0091b0',
      cancelButtonColor: '#88A09E',
      reverseButtons: true,
      cancelButtonText: this.$t('message.ob_submit_swal_reject').toString(),
      confirmButtonText: this.$t('message.ob_submit_swal_confirm').toString()
    }).then((result) => {
      if (result.value) {
        this.massiveApprove = true
        this.isActiveMode = true
        id.forEach((element, index) => {
          approvePromises.push(this.ob.Aprove(`${element}`))
        })

        if (this.isIEbrowser) {
          if (this.hasVPIntegration) {
            swal({
              type: 'warning',
              text: this.$t(
                'message.sichernIntegrations.activateOnboarding.errorIE'
              ).toString(),
              showConfirmButton: true
            }).then(() => {
              this.massiveApprove = false
              this.isActiveMode = false
            })
          } else {
            Promise.all(approvePromises)
              .then((values) => {
                swal(
                  this.$t('message.ob_activated_swal_title').toString(),
                  this.$t('message.ob_activated_swal_text').toString(),
                  'success'
                ).then(() => {
                  if (that.getHasPerformanceIntegration) {
                    that.$router.push('/employees/list')
                  } else {
                    that.searchEmployees(that.limit, 1, '')
                    that.massiveApprove = false
                    that.isActiveMode = false
                  }
                })
              })
              .catch((error) => {
                let msg
                let knowCodes = ['50010', '05006']
                let errorText = ''
                if (knowCodes.includes(error.response.data.code.toString())) {
                  if (error.response.data.hasOwnProperty('error')) {
                    errorText = error.response.data.error + ' - '
                  }
                  msg =
                    errorText +
                    this.$t(
                      'message.error_' + error.response.data.code + '_1'
                    ) +
                    '. ' +
                    this.$t('message.error_' + error.response.data.code + '_2')
                } else {
                  msg = this.$t('message.error_' + error.response.data.code)
                }
                swal({
                  type: 'error',
                  title: 'Error',
                  text: msg,
                  showConfirmButton: true
                })

                that.searchEmployees(that.limit, 1, '')
                that.massiveApprove = false
                that.isActiveMode = false
              })
          }
        } else {
          Promise.allSettled(approvePromises).then((response) => {
            let errors = []
            errors = response.filter((value) => {
              return (
                value.status === 'rejected' ||
                (value.status === 'fulfilled' &&
                  value.value.status === 201 &&
                  value.value.data.code === 'SICHERN_PEOPLE_ADDITIONAL_DATA')
              )
            })
            if (!errors.length) {
              swal(
                this.$t('message.ob_activated_swal_title').toString(),
                this.$t('message.ob_activated_swal_text').toString(),
                'success'
              ).then(() => {
                if (that.getHasPerformanceIntegration) {
                  that.$router.push('/employees/list')
                } else {
                  that.searchEmployees(that.limit, 1, '')
                  that.isActiveMode = false
                  that.massiveApprove = false
                }
              })
            } else {
              let modalText = ''
              let csvErrors = []
              csvErrors = errors
                .filter((error) => {
                  if (error.reason) {
                    return that.hasIntegrationErrors(
                      error.reason.response.data.code
                    )
                  } else {
                    return that.hasIntegrationErrors(error.value.data.code)
                  }
                })
                .map((error) => {
                  let msjErrores = ''
                  if (
                    error.reason &&
                    error.reason.response.data.code ===
                      'SICHERN_PEOPLE_VALIDATION'
                  ) {
                    error.reason.response.data.data.messages.forEach(
                      (message, index) => {
                        if (index > 0) {
                          msjErrores =
                            `${msjErrores} | ` +
                            this.$t(
                              `message.sichernIntegrations.activateOnboarding.massive_validations.${message}`
                            ).toString()
                        } else {
                          msjErrores = this.$t(
                            `message.sichernIntegrations.activateOnboarding.massive_validations.${message}`
                          ).toString()
                        }
                      }
                    )
                    return [
                      `${error.reason.response.data.data.name}`,
                      `${msjErrores}`
                    ]
                  } else {
                    return [
                      `${
                        error.reason
                          ? error.reason.response.data.data.name
                          : error.value.data.data.name
                      }`,
                      this.$t(
                        `message.sichernIntegrations.activateOnboarding.massive_validations.${
                          error.reason
                            ? this.mediatorMessage(error.reason.response.data)
                            : error.value.data.code
                        }`
                      ).toString()
                    ]
                  }
                })

              if (csvErrors.length) {
                modalText = this.$t(
                  'message.sichernIntegrations.activateOnboarding.ob_massive_download_csv'
                ).toString()
              }

              swal({
                type: 'error',
                title: this.$t(
                  'message.ob_massive_general_error_response'
                ).toString(),
                text: modalText,
                showConfirmButton: true,
                showCancelButton: csvErrors.length ? true : false,
                reverseButtons: true,
                confirmButtonText: csvErrors.length
                  ? this.$t(
                      'message.sichernIntegrations.activateOnboarding.dowload_btn'
                    ).toString()
                  : this.$t('message.ob_submit_swal_got_it').toString(),
                cancelButtonText: this.$t(
                  'message.sichernIntegrations.activateOnboarding.cancel_btn'
                ).toString()
              }).then((evt) => {
                if (evt.value && csvErrors.length) {
                  that.downloadCSVErrorsFile(
                    'erroresActivacionOnboarding.csv',
                    csvErrors
                  )
                }
              })
              that.searchEmployees(that.limit, 1, '')
              that.isActiveMode = false
              that.massiveApprove = false
            }
          })
        }
      }
    })
    this.search.userIds = []
  }

  mediatorMessage(data) {
    const mediatorCustomCode = [
      'SICHERN_PEOPLE_POST_MEDIATOR_BAD_REQUEST',
      'SICHERN_PEOPLE_PUT_MEDIATOR_BAD_REQUEST'
    ]
    if (mediatorCustomCode.includes(data.code)) {
      const { messages } = data.data
      return data.code + '.' + messages[0]
    }
    return data.code
  }

  async checkActiveSichernPeopleIntegration() {
    try {
      const type = 'VP_ONBOARDING'
      const response = await this.vi.checkIntegrationSichernPeopleByType(type)
      this.hasVPIntegration = response.data.data.enabled
    } catch (error) {
      console.error(error)
    }
  }

  isIE() {
    let ua = window.navigator.userAgent
    let msie = ua.indexOf('MSIE ')
    let trident = ua.indexOf('Trident/')
    let edge = ua.indexOf('Edge/')
    if (msie > 0 || trident > 0 || edge > 0) {
      this.isIEbrowser = true
    }
  }

  hasSichernPeopleErrors(codeError) {
    const sichernErrors = [
      'SICHERN_PEOPLE_VALIDATION',
      'SICHERN_PEOPLE_MEDIATOR',
      'SICHERN_PEOPLE_INVALID_POST_VALUES_MEDIATOR',
      'EXTERNAL_API_COULD_NOT_CONNECT',
      'SICHERN_PEOPLE_ADDITIONAL_DATA',
      'SICHERN_PEOPLE_POST_MEDIATOR_BAD_REQUEST',
      'SICHERN_PEOPLE_PUT_MEDIATOR_BAD_REQUEST'
    ]
    
    return sichernErrors.includes(codeError)
  }

  hasPerformanceErrors(codeError) {
    const performanceErrors = [
      'PERFORMANCE_CONFIGURATION_ERROR',
      'PERFORMANCE_VALIDATION',
      'PERFORMANCE_AUTHENTICATION_ERROR',
      'PERFORMANCE_SEND_DATA_ERROR',
      'PERFORMANCE_UNEXPECTED_ERROR'
    ]
    
    return performanceErrors.includes(codeError)
  }

  hasIntegrationErrors(codeError) {
    return this.hasSichernPeopleErrors(codeError) || this.hasPerformanceErrors(codeError)
  }

  downloadCSVErrorsFile(filename, errors) {
    let csvFile = 'Usuario,Error\n'
    errors.forEach((row) => {
      csvFile += row.join(',')
      csvFile += '\n'
    })

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' })
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename)
    } else {
      var link = document.createElement('a')
      if (link.download !== undefined) {
        var url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }

  async sendNotification(ids) {
    if (_.isEmpty(ids)) {
      return
    }
    const response = await this.obApi.sendNotification(ids)
    this.showResponseNotification = true
    this.responseNotification = response.data.data
  }
  searchToStore() {
    this.$store.dispatch('setSearchRRHH', { search: this.search })
  }

  addFolder() {
    if (this.companyFolders.length !== 0) {
      let selected = (<HTMLInputElement>document.getElementById('perfilSector'))
        .value
      this.companyFolders.forEach((element, index) => {
        if (element.carpeta_id === selected.toString()) {
          this.companyFolders.splice(index, 1)
          this.foldersUser.push(element)
        }
      })
    }
  }

  removeItem(index) {
    this.companyFolders.push(this.foldersUser[index])
    this.foldersUser.splice(index, 1)
  }
  getIdCompany() {
    this.$store
      .dispatch('getProfile')
      .then((res: any) => {
        this.searchSectorLocacion()
        this.companyId = res.empresa.id
        this.activeId = res.id
      })
      .catch((error: any) => {})
  }
  getFolders() {
    this.showFolderSpinner = false
    this.companyFolders = []
    this.foldersClient
      .getFoldersAvailable(this.companyId)
      .then((res: any) => {
        this.companyFolders = res.data.results.data
      })
      .catch((error: any) => {})
  }
  getFoldersUser(userId) {
    this.showFolderSpinner = true
    this.userActive = userId
    this.foldersUser = []
    this.companyFolders = []
    this.foldersClient
      .getFoldersAvailable(this.companyId)
      .then((res: any) => {
        if (res.status === 200) {
          this.companyFolders = res.data.results.data
          this.foldersClient
            .getFoldersUser(this.userActive)
            .then((res: any) => {
              if (res.status === 200) {
                if (res.data.length > 0) {
                  for (let i = 0; i < res.data.length; i++) {
                    const params = {
                      carpeta_id: res.data[i].idcarpeta,
                      carpeta_nombre: res.data[i].name
                    }
                    this.companyFolders.forEach((element, index) => {
                      if (element.carpeta_nombre === res.data[i].name) {
                        this.companyFolders.splice(index, 1)
                      }
                    })
                    this.foldersUser.push(params)
                  }
                }
              }
            })
            .catch((error: any) => {
              if (error.status === 404) {
                this.foldersUser = []
              }
            })
        }
        this.showFolderSpinner = false
      })
      .catch((error: any) => {
        this.showFolderSpinner = false
      })
  }
  saveFolders() {
    let foldersAux = []
    this.foldersUser.forEach((element, index) => {
      foldersAux.push(element.carpeta_id)
    })
    const params = {
      idusuario: this.userActive,
      idcarpeta: foldersAux.join(',')
    }
    this.foldersClient
      .deleteFoldersUser(this.userActive)
      .then((res: any) => {
        if (res.status === 200) {
          if (this.foldersUser.length > 0) {
            this.foldersClient.addFoldersUser(params).then(() => {
              swal({
                type: 'success',
                title: `${this.$t(
                  'message.employees_list_modal_swal_correct'
                )}`,
                showConfirmButton: true,
                confirmButtonText: `${this.$t(
                  'message.billboard_form_post_button_confirm'
                )}`
              }).then(() => {
                this.companyFolders = []
              })
            })
          } else {
            swal({
              type: 'success',
              title: `${this.$t('message.employees_list_modal_swal_correct')}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t(
                'message.billboard_form_post_button_confirm'
              )}`
            }).then(() => {
              this.companyFolders = []
            })
          }
        }
      })
      .catch((error: any) => {})
  }
  mouseOver(userPerfiles: any) {
    this.mouseOverReset = true
    if (userPerfiles.perfiles != null) {
      if (
        userPerfiles.estado_empresa === '1' &&
        userPerfiles.perfiles.includes('"id_perfil_tipo" : 2') &&
        userPerfiles.id != this.activeId
      )
        this.overShowFolder = true
      else this.overShowFolder = false
    } else {
      if (
        userPerfiles.estado_empresa === '1' &&
        userPerfiles.id_perfil_tipo === 2 &&
        userPerfiles.id != this.activeId
      )
        this.overShowFolder = true
      else this.overShowFolder = false
    }
  }
  getResetPassword(userId, userMail, userUser) {
    this.form.resetPass.id = userId
    this.form.resetPass.user = userUser
    this.form.resetPass.mail = userMail
    this.userClient
      .getDomain(userId)
      .then((result) => {
        if (result.status === 200) {
          console.log(result.data.results.data[0].aplicacion.dominio)
        }
      })
      .catch((error) => {})
  }
  passwordChange() {
    this.$validator.validate().then((result) => {
      if (result) {
        this.userClient
          .changeMailResetPass(this.form.resetPass.id, this.form.resetPass.mail)
          .then((result) => {
            if (result.status === 200) {
              this.userClient
                .resetPassRequest(
                  this.form.resetPass.user,
                  this.form.resetPass.mail
                )
                .then((result) => {
                  if (result.status === 200) {
                    swal({
                      type: 'success',
                      title: `${this.$t(
                        'message.employees_list_modal_reset_pass_correct'
                      )}`,
                      showConfirmButton: true,
                      confirmButtonText: `${this.$t(
                        'message.billboard_form_post_button_confirm'
                      )}`
                    }).then(() => {
                      this.reloadTable(this.page)
                      document
                        .getElementById('resetModal')
                        .classList.remove('show')
                      document
                        .getElementsByClassName('modal-backdrop')[0]
                        .classList.remove('show')
                    })
                  }
                })
                .catch((error) => {
                  swal({
                    type: 'error',
                    title: `${this.$t(
                      'message.employees_list_modal_reset_pass_incorrect'
                    )}`,
                    showConfirmButton: true,
                    confirmButtonText: `${this.$t(
                      'message.billboard_form_post_button_confirm'
                    )}`
                  }).then(() => {
                    this.reloadTable(this.page)
                    document
                      .getElementById('resetModal')
                      .classList.remove('show')
                    document
                      .getElementsByClassName('modal-backdrop')[0]
                      .classList.remove('show')
                  })
                })
            }
          })
          .catch((error) => {
            swal({
              type: 'error',
              title: `${this.$t(
                'message.employees_list_modal_reset_pass_incorrect_change'
              )}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t(
                'message.billboard_form_post_button_confirm'
              )}`
            }).then(() => {
              this.reloadTable(this.page)
              document.getElementById('resetModal').classList.remove('show')
              document
                .getElementsByClassName('modal-backdrop')[0]
                .classList.remove('show')
            })
          })
      }
    })
  }

  async exportUserList() {
    this.isExportingLoader = true
    var params = this.buildFilter()
    params.append('download', '1')
    await this.ob
      .searchEmployees(this.total, this.page, params)
      .then((response) => {
        if (response.status === 200) {
          let request = response.request
          let disposition = request.getResponseHeader('content-disposition')
          let matches = /"([^"]*)"/.exec(disposition)
          let filename =
            matches != null && matches[1] ? matches[1] : 'empleados.xls'
          var blob = new Blob([request.response], {
            type: 'application/vnd.ms-excel;charset=utf-8'
          })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.isExportingLoader = false
        }
      })
      .catch((e) => {
        this.isExportingLoader = false
      })
  }
  buildingFilter(value) {
    var params = new URLSearchParams()
    if (value.length != 0) {
      params.append('principal', value)
    }
    return params
  }
  buildFilterForReport(value) {
    var params = new URLSearchParams()
    if (value.length != 0) {
      params.append('search', value)
    }
    return params
  }
  searchingEmployees(value) {
    let that = this
    that.search.report.datos = []
    if (value.length > 2 && that.bufferFree) {
      that.paramsPositionReport = that.buildFilterForReport(value)
      this.searchReport_to()
    }
  }
  searchReport_to() {
    let that = this
    that.bufferFree = false
    that.isLoading = true
    that.ob
      .SearchEmployeesToReport(this.paramsPositionReport)
      .then((res) => {
        if (res.status === 200) {
          // that.isLoading = false
          let auxData = res.data
          auxData.forEach((element) => {
            let reporter = {
              name: '',
              cuil: ''
            }
            reporter.name = element.nombre + ' ' + element.apellido
            reporter.cuil = element.cuil
            that.search.report.datos.push(reporter)
            that.bufferFree = true
          })
        }
        that.isLoading = false
      })
      .catch((error) => {
        that.isLoading = false
        that.search.report.datos = []
        that.bufferFree = true
      })
  }
  cleanPosition() {
    this.search.cargo.data = []
  }
  addTagPosition(newTag) {
    this.cleanPosition()
    this.search.cargo.push(newTag)
  }
  clearReport() {
    this.search.report.value = []
  }
  clearPosition() {
    this.search.cargo.value = []
  }
  disableState(profile) {
    const type =
      profile.id_perfil_tipo !== '4' && profile.id_perfil_tipo !== '8'
        ? profile.id_perfil_tipo
        : profile.id
    return (
      (this.search.checkedTipoPerfil.length &&
        this.search.checkedTipoPerfil.indexOf(type) === -1) ||
      this.searchDisabled
    )
  }
}
